import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getRangeValue } from '../../../packages/JsonQuery';
import { DEFAULT_RANGE_VALUE } from 'shared/constants/defaultValues';

export const selectFromMkadKm = createSelector(
  selectJsonQuery,
  jsonQuery => getRangeValue('from_mcad_km')(jsonQuery) || DEFAULT_RANGE_VALUE,
);
